import React, { useState, useEffect } from 'react';
import Lottie from 'lottie-react';

const LoadingAnimation = ({ className, delay = 300 }) => {
  const [animationData, setAnimationData] = useState(null);
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    fetch('https://cdn.prod.website-files.com/64eb6710f68f6b333f8886a6/65df5eef87cad451c6794d4b_Loading%20Animation%20(1).json')
      .then(response => response.json())
      .then(data => setAnimationData(data))
      .catch(error => console.error('Error loading animation:', error));
  }, []);

  useEffect(() => {
    // Set a timeout to show the animation after the delay
    const timer = setTimeout(() => {
      setShouldShow(true);
    }, delay);

    // Clear the timeout if the component unmounts
    return () => clearTimeout(timer);
  }, [delay]);

  // Don't show anything until the delay has passed
  if (!shouldShow || !animationData) {
    return null;
  }

  return (
    <div className={`loading-container ${className || ''}`}>
      <Lottie
        animationData={animationData}
        loop={true}
        style={{ width: 120, height: 120 }}
      />
    </div>
  );
};

export default LoadingAnimation; 